import { defineStore } from 'pinia';

import { fetchWrapper } from '@/helpers/fetch-wrapper';

// import router from '@/router'

const baseUrl = `${import.meta.env.VITE_BASE_URL}`;

export const useUserStore = defineStore({
    id: 'user',
    state: () => ({
        username: null,
        firstName: null,
        lastName: null,
        telefon: null,
        // userEmail: null,
        userAvatar: null,
        atWork: 0,
        atLunch: 0,
        tguserId: 0,
        id: 0,
        balance: 0,
        permissions: JSON.parse(localStorage.getItem('permissions')) ? JSON.parse(localStorage.getItem('permissions')) : []
    }),
    actions: {
        setUser(user) {
            this.username = user.username;
            this.firstName = user.first_name;
            this.lastName = user.last_name;
            // this.userEmail = user.email;
            this.telefon = user.telefon;
            this.atWork = user.at_work;
            this.atLunch = user.at_lunch;
            this.tguserId = user.tguser_id;
            this.id = user.id;
            this.permissions = user.available_functions ? user.available_functions : []
            localStorage.setItem('permissions', JSON.stringify(this.permissions));
        },
        setBalance(balance){
            this.balance = balance || 0;
        },
        async changeUser(user) {
            return new Promise((resolve, reject) => {
                fetchWrapper.patch(`${baseUrl}/auth/users/me/`, user).then((user) => {
                    this.setUser(user);
                    resolve('ok')
                }).catch((error) => {
                    reject(error)
                });
            }
            )
        },
        async setNewPassword(current_password, new_password) {
            return new Promise((resolve, reject) => {
                fetchWrapper.post(`${baseUrl}/auth/users/set_password/`, { current_password, new_password }).then(() => {
                    resolve('ok')
                }).catch((error) => {
                    reject(error)
                });
            }
            )
        },
        async getUsersList(query = null) {
            let url = new URL(`${baseUrl}/auth/users/`)
            url.searchParams.set('limit', '100000')
            if (query != null) {
                try {
                    query.forEach((value, key) => url.searchParams.set(key, value))
                } catch (err) {
                    console.log(err, query)
                }
            }
            return new Promise((resolve, reject) => {
                fetchWrapper.get(new String(url)).then((response) => {
                    resolve(response.results)
                }).catch((error) => {
                    reject(error)
                });
            }
            )
        },
        async getUserBalance() {
            let url = new URL(`${baseUrl}/auth/users/balance/`)
            return new Promise((resolve, reject) => {
                fetchWrapper.get(new String(url)).then((response) => {
                    this.setBalance(response.balance)
                    resolve(response.balance)
                }).catch((error) => {
                    reject(error)
                });
            }
            )
        },
        can(permission) {
            if (permission.constructor.name === "Array") {
                return permission.every((item) => this.permissions.includes(item))
            }
            return this.permissions.includes(permission)
        },
        checkState(state) {
            if (state === "atWork"){
                return this.atWork !== 0
            } else if (state === "!atWork"){
                return this.atWork === 0
            }  else if (state === "atLunch"){
                return this.atLunch !== 0
            } else if (state === "!atLunch"){
                return this.atLunch === 0
            }
        },
        checkStates(states){
            if (states.constructor.name === "Array") {
                return states.every(this.checkState)
            }
            return this.checkState(states)
        },
        async toogleAtWork() {
            if (!this.atWork) {
                return new Promise((resolve, reject) => {
                    fetchWrapper.post(`${baseUrl}/work_days/`, {}).then((response) => {
                    this.atWork = response.id
                    if (!this.atWork) { this.atLunch = 0 }
                    resolve('ok')
                }).catch((error) => {
                    if (!this.atWork) { this.atLunch = 0 }
                    reject(error)
                });
                })
            } else {
                return new Promise((resolve, reject) => {
                    fetchWrapper.patch(`${baseUrl}/work_days/${this.atWork}/end/`, {}).then(() => {
                        this.atWork = 0
                        this.atLunch = 0
                        resolve('ok')
                    }).catch((error) => {
                        if (!this.atWork) { this.atLunch = 0 }
                        reject(error)
                    });
                })
            }
        },
        async toogleAtLunch(){
            if (!this.atLunch) {
                return new Promise((resolve, reject) => {
                    fetchWrapper.post(`${baseUrl}/lunchs/`, {}).then((response) => {
                    this.atLunch = response.id
                    resolve('ok')
                }).catch((error) => {
                    reject(error)
                });
                })
            } else {
                return new Promise((resolve, reject) => {
                    fetchWrapper.patch(`${baseUrl}/lunchs/${this.atLunch}/end/`, {}).then(() => {
                        this.atLunch = 0
                        resolve('ok')
                    }).catch((error) => {
                        reject(error)
                    });
                })
            }
        }
    },
    getters: {
        userName: (state) => {
            if (state.firstName && state.lastName) {
                return `${state.firstName} ${state.lastName}`
            } else if (state.username) {
                return state.username
            } else { return '' }
        },
        getPermissions: (state) => {
            return state.permissions
        },
        avatar: (state) => {
            if (state.userAvatar) {
                return state.userAvatar
            }
            const userName = `${state.username}`
            return `https://api.dicebear.com/7.x/avataaars/svg?seed=${userName.replace(
                /[^a-z0-9]+/gi,
                '-'
            )}`
        }
    },
});